import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';

import { AlertService, AuthenticationService } from '../_services';
import { Globals } from '../_helpers';
import { HttpHeaders, HttpClient } from '@angular/common/http';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
  selector: 'app-forget-username',
  templateUrl: './forget-username.component.html',
  styleUrls: ['./forget-username.component.css']
})

export class ForgetUsernameComponent implements OnInit {

    @ViewChild('alertBrowser') private alertBrowser: SwalComponent;

    public alertOption: SweetAlertOptions = {};

    emailFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern("[^ @]*@[^ @]*"),
    ]);
       
    mobileFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern("[0-9]{10}"),
    ]);
    comFormControl = new FormControl('', [
        Validators.required,
    ]);       
  
    matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg: string;
    returnUrl: string;
    isShowPass = true;
    isReset = false;
    resetMsg: string;
    hide = true;
    list_type: number = 2;
    info:any;
    getData = false;
    isSuccess = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private http: HttpClient

    ) { }


    ngOnInit() {        
        //this.returnUrl = '/';
    }

/*    ngAfterViewInit() {
        this.detectBrowserSuport();
    }*/
    keys : any;
    onSubmit() {        
        this.submitted = true;
        /* stop here if form is invalid */
        if (this.mobileFormControl.value == '') {
        	//this.errorMsg = 'Email and Mobile can not blank. !!';
            this.isErrorLogin = false;
            return false;
        }
        else {      	
            this.loading = true;
            this.spinner.show();
            this.authenticationService.forgetUsername(this.globals.root_url, this.mobileFormControl.value)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {                                                 
                            this.isErrorLogin = false;
                            this.isSuccess = true;
                            this.errorMsg = "Your username has been sent to your mobile number after matching our records. You will be redirected to the login page within 10 seconds.";
                            this.spinner.hide();   
                            let that = this;
                            that.keys = setInterval(() => {
                            if(that.isSuccess == true)
                            {
                                clearInterval( that.keys ); 
                                that.dologin();                    
                            }
                            }, 8000);                                                                  
                        }
                        else {
                            this.isErrorLogin = true;
                            this.isSuccess = false; 
                            this.errorMsg = data.status;
                            this.loading = false;
                            this.spinner.hide();
                        }
                    },
                    error => {
                        this.isErrorLogin = true;
                        this.errorMsg = 'Invalid Login code !!';
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                    }
                );
        }
    }

    private detectBrowserSuport() {
        let isSupport = true;
        let video = document.createElement('video');
        if (video.canPlayType('video/ogg; codecs="theora"') == "")
            isSupport = false;

        if (video.canPlayType('video/mp4; codecs="avc1.42E01E"') == "")
            isSupport = false;

        if (video.canPlayType('video/webm; codecs="vp8, vorbis"') == "")
            isSupport = false;

        if (video.canPlayType('video/webm; codecs="vp9"') == "")
            isSupport = false;

        const audio = document.createElement('audio');
        if (audio.canPlayType('audio/mpeg') == "")
            isSupport = false;

        if (audio.canPlayType('audio/wav') == "")
            isSupport = false;

        if (!isSupport) {
            this.alertBrowser.show();
            //alert('Your brawser is unsupported, please update your brawser.');
        }
        else {
            console.log('ok');
        }

    }

    showPass() {
        this.isShowPass = false;
    }
    showLogin() {
        this.isShowPass = true;
    }
    dologin() {
        this.router.navigate(['/userlogin'])
    }
}


